class WarrantyPopup extends HTMLElement {
    constructor() {
        super();

        this.popup = this;
        this.timeToShow = parseInt(this.popup.getAttribute('data-delay'));
		var popup = this.popup;
		
		if(document.querySelector('[data-open-warranty-popup]')){
          document.querySelector('[data-open-warranty-popup]').addEventListener('click',this.setOpenPopup.bind(this))
        }
        document.body.addEventListener('click', this.onBodyClickEvent.bind(this));

        this.querySelector('[data-close-warranty-popup]').addEventListener(
            'click',
            this.setClosePopup.bind(this)
        );
    }

    setOpenPopup() {
		setTimeout(function() {
			document.body.classList.add('warranty-show');
		}, this.timeToShow);
    }
    

    setClosePopup() {
        document.body.classList.remove('warranty-show');
        setTimeout(() => {
            document.body.classList.remove('show-warranty-image');
        }, 700)
    }

    onBodyClickEvent(event){
        if ((!this.contains(event.target)) && ($(event.target).closest('[data-open-warranty-popup]').length === 0) && document.querySelector('body').classList.contains('warranty-show')){
            this.setClosePopup();
        }
    }
}

customElements.define('elspet-warranty-popup', WarrantyPopup);